import dayjs from "dayjs"
import pluralize from "pluralize"

import useDateFormatters from "@hooks/useDateFormatters"

import { faIcon } from "@utils/faIcon"
import { formatRelativeTime } from "@utils/relativeTime"

import { Badge, ColorBadge } from "@atoms"

import { TermsBadgeProps } from "./TermsBadge.types"

const icon = faIcon({ name: "square-n", style: "regular" })

export default function TermsBadge(props: TermsBadgeProps) {
    const { variant, size = "md" } = props

    const { formatDate } = useDateFormatters()

    const netDays = variant === "fixed" ? props.netDays : dayjs(props.dateDue).diff(dayjs(props.dateIssued), "day")
    const isExpired = variant === "dates" && props.isExpired

    let tooltip: string
    if (variant === "fixed") {
        // e.g. "Default payment terms\n30 days".
        tooltip = `${props.label}\n${pluralize("day", netDays, true)}`
    } else {
        // e.g. "Expires\nin 10 days\non January 1, 2025" or "Expired\n10 days ago\non January 1, 2025". The
        // past-tense label follows the date itself, so a settled object past its due date still reads "Expired"
        // without the expired look.
        const { label = "Expires", expiredLabel = "Expired" } = props
        const isPastDue = dayjs(props.dateDue).isBefore(dayjs(), "day")
        const dueDate = formatDate(props.dateDue, "long")
        tooltip = `${isPastDue ? expiredLabel : label}\n${formatRelativeTime(props.dateDue)}\non ${dueDate}`
    }

    if (isExpired) {
        return (
            <ColorBadge colorScheme="tomato" size={size} variant="icon" icon={icon} tooltip={tooltip}>
                {netDays}
            </ColorBadge>
        )
    } else {
        return (
            <Badge size={size} variant="icon" icon={icon} tooltip={tooltip}>
                {netDays}
            </Badge>
        )
    }
}
